document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".add-to-cart");

  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      const variantId = this.getAttribute("data-variant-id");
      const productId = this.getAttribute("data-product-id");

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      })
      
        .then((response) => {
          if (response.ok) {
            // 2024.4.10 Add start : Display custom popup
            const customPopupId = `popup--${productId}`;
            const customPopup = document.getElementById(customPopupId);
            // When added to cart
            fetch(`/cart.js`, {
              credentials: 'same-origin',
              method: 'GET'
            }).then(function (response) {
              response.json().then(function (result) {
                var cartResult = result;
                var cartDot = document.querySelectorAll('.Header__CartDot');
                cartDot.forEach(function (item) {
                  if (cartResult.item_count === 0) {
                    item.classList.remove('is-visible'); // IE 11 and lower does not support second attribute of toggle :(
                  } else {
                    item.classList.add('is-visible');
                  }
                  item.textContent = cartResult.item_count;
                });

                var popupUpsell = customPopup.querySelector(".c-popup-upsell");
                var freeShippingAmount = parseInt(popupUpsell.getAttribute('data-free_shipping_amount')) * 100;

                const upsellAmount = ( freeShippingAmount - cartResult.total_price ) /100;
                // 送料無料キャンペーン期間中は、しきい値の案内ではなくキャンペーンの案内を出す。
                // 期間外は null が返るので、下の今までどおりの分岐に落ちる。
                const campaignHtml = window.freeShippingCampaignHtml ? window.freeShippingCampaignHtml() : null;
                if(campaignHtml){
                  popupUpsell.innerHTML = `
                    商品点数：合計${cartResult.item_count}点<br/>
                    ${campaignHtml}
                  `;
                }else if(cartResult.total_price < freeShippingAmount){
                  popupUpsell.innerHTML = `
                    商品点数：合計${cartResult.item_count}点<br/>
                    あと${upsellAmount.toLocaleString()}円のご購入で、送料が無料になります。<br/>
                    <small>※一部商品は対象外となります</small>
                  `;
                }else{
                  popupUpsell.innerHTML = `
                    商品点数：合計${cartResult.item_count}点<br/>
                    15,000円以上お買い上げのため送料無料でお届けします。<br/>
                    <small>※一部商品は対象外となります</small>
                  `;
                }

                openCustomPopup(customPopupId);
              })
              .catch(function (error) {
                console.log(error);
              });
            });
            // 2024.4.10 Add end : Display custom popup
          } else {
            alert("在庫が足りないため、カートに追加できません。")
            response.json().then(function (content) {
              console.error(content.description);
            });
          }
        });
    });
  });
});
